// extracted by mini-css-extract-plugin
module.exports = {"AdSlotOffsite":"bgf_a bhb_bi"};